// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3X8n0","colMaxWidth":"Table_colMaxWidth__2zsUz"};